module.exports = __webpack_public_path__ + "static/media/logo-rhyzos.43b91068.svg";